import React, { useState, useEffect, useRef, useMemo } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Container, Row, Col, Button } from "react-bootstrap";
import PersonIcon from "@mui/icons-material/Person";
import { IconButton, InputAdornment } from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/AddUser.css";
import moment from "moment-timezone";
import Axios from "axios";
import { useNavigate } from "react-router-dom";
import SwapSection from "./SwapSection";
import { useDispatch, useSelector } from "react-redux";
import translations from "../assets/locals/translations";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { setShowMessage } from "../redux/slices/notificationSlice";
import {
  addemployeeToDb,
  clearAddemployeeState,
} from "../redux/slices/addemployeeSlice";
import {
  clearEditemployeeData,
  clearEditemployeeState,
  editemployeeUpdateToDb,
} from "../redux/slices/editemployeeDataSlice";

const EmployeeForm = ({ workFor }) => {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [profileUrl, setProfileUrl] = useState("");
  const fileInputRef = useRef(null); // Create a ref for the file input
  const [accessType, setAccessType] = useState("appaccess");
  const bloodGroups = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];
  const [roles, setRoles] = useState([]);
  const [banklist, setBankList] = useState([]);
  const [branches, setBranchs] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [popUpScreen, setPopUpScreen] = useState(false);
  const [branchRoles, setBranchRoles] = useState({});
  const [reportinManagerList, setReportinManagerList] = useState([]);
  const [branchId, setBranchId] = useState();
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const dispatch = useDispatch();
  const currentLanguage = useSelector((state) => state.language.language);
  const t = translations[currentLanguage] || translations['en'];
  const addemployeeState = useSelector(
    (state) => state.addemployeeSlice.addemployeeState
  );
  const { editemployeeSliceState } = useSelector(
    (state) => state.editemployeeDataState
  );

  const editemployeeData = useSelector(
    (state) => state.editemployeeDataState.editemployeeData.data
  );

  let initialBirthdate;
  if (editemployeeData && workFor === "Edit") {
    initialBirthdate = formatDateOfBirth(editemployeeData.dob);
  }

  const [initialValues, setInitialValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    birthdate: initialBirthdate || "",
    bloodgroup: "",
    bankname: "",
    bankbranch: "",
    accountNumber: "",
    accountType: "",
    ifscCode: "",
    department: "",
    reportingManager: "",
  });

  const selectInp = useRef();
  const selectedInp = useRef();
  const leftArrowBtn = useRef();
  const rightArrowBtn = useRef();

  const navigate = useNavigate();

  useEffect(() => {
    if (!editemployeeData && workFor === "Edit") {
      console.log("Working.......");
      navigate("/administration/employees");
    }
  }, [editemployeeData, workFor, navigate]);

  // const profileUrl =
  //   workFor === "Edit" && editemployeeData !== null
  //     ? `${process.env.REACT_APP_NODE_URL}/api/${editemployeeData.document_path}`
  //     : "";

  // Function to fetch the profile image
  const fetchProfileImage = async (filename) => {
    try {
      const response = await Axios.get(
        `${process.env.REACT_APP_NODE_URL}/api/employees/get-employee-profile/${filename}`,
        { responseType: "blob" }
      );

      if (response.status === 200) {
        const imageUrl = URL.createObjectURL(response.data); // Blob to URL
        setProfileUrl(imageUrl); // Store the generated URL
      } else {
        setProfileUrl(null);
      }
    } catch (err) {
      console.error("Error fetching profile image:", err);
      // setError("Profile picture not found");
    }
  };

  useEffect(() => {
    if (workFor === "Edit" && editemployeeData?.document_path) {
      fetchProfileImage(editemployeeData.document_path);
    }
  }, [editemployeeData]);
  function formatDateOfBirth(dobString) {
    const defaultDate = moment.tz("Asia/Kolkata").format("YYYY-MM-DD"); // Today's date in Asia/Kolkata

    if (dobString) {
      // Parse the date string as UTC and then convert to Asia/Kolkata time zone
      const dateFromDb = moment
        .tz(dobString, "Asia/Kolkata")
        .format("YYYY-MM-DD");
      if (moment(dateFromDb, "YYYY-MM-DD", true).isValid()) {
        return dateFromDb; // Return formatted date
      }
    }

    return defaultDate; // Fallback to today's date
  }
  useEffect(() => {
    if (workFor === "Edit" && editemployeeData) {
      setInitialValues({
        firstName: editemployeeData.first_name || "",
        lastName: editemployeeData.last_name || "",
        email: editemployeeData.email || "",
        phone: editemployeeData.phone_number || "",
        password: "passWord123!" || "",
        birthdate: initialBirthdate,
        bloodgroup: editemployeeData.bloodgroup || "",
        bankname: editemployeeData.bank_name || "",
        bankbranch: editemployeeData.bank_branch || "",
        accountNumber: editemployeeData.account_number || "",
        accountType: editemployeeData.account_type || "",
        ifscCode: editemployeeData.ifsc_code || "",
        department: editemployeeData.department_id || "",
        reportingManager: editemployeeData.reportingmanager || "",
      });
    }
  }, [workFor, editemployeeData, initialBirthdate]);

  const validationSchema = Yup.object({
    firstName: Yup.string()
      .max(50, t.must_be_50 || "Must be 50 characters or less")
      .required(t.required || "Required"),
    lastName: Yup.string()
      .max(50, t.must_be_50 || "Must be 50 characters or less")
      .required(t.required || "Required"),
    email: Yup.string().email(t.invalid_email || "Invalid email address").required(t.required || "Required"),
    phone: Yup.string()
      .matches(/^[0-9]{10}$/, t.must_be_10_digits || "Must be exactly 10 digits")
      .required(t.required || "Required"),
    password: Yup.string().required(t.password_required || "Password Required"),
    birthdate: Yup.date()
      .max(new Date(), t.birthdate_future || "Birthdate cannot be in the future")
      .required(t.required || "Required"),
    bloodgroup: Yup.string().required(t.required || "Required"),
    bankname: Yup.string().required(t.required || "Required"),
    bankbranch: Yup.string().required(t.required || "Required"),
    accountNumber: Yup.string().required(t.required || "Required"),
    accountType: Yup.string().required(t.required || "Required"),
    ifscCode: Yup.string().required(t.required || "Required"),
    department: Yup.string().required(t.required || "Required"),
    reportingManager: Yup.string().required(t.required || "Required"),
    // position: Yup.string().required("Required"),
    // department: Yup.string().required("Required"),
    // hireDate: Yup.date().required("Required"),
  });
  useEffect(() => {
    if (addemployeeState.isSuccess) {
      if (addemployeeState.message.result === "success") {
        dispatch(setShowMessage(t.employeecreated || "Employee Succesfully Created"));
        // clearInpHook();
        dispatch(clearAddemployeeState());
        navigate("/administration/employees");
      } else if (addemployeeState.message.result === "alreadyExist") {
        dispatch(setShowMessage(t.email_already_exist || "*Please use a different email to continue!"));
        dispatch(clearAddemployeeState());
      }
    }
  }, [addemployeeState]);

  async function getRolesFromDb() {
    const url = `${process.env.REACT_APP_NODE_URL}/api/users/roles-list`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await Axios.get(url, config).then((response) => {
      if (response.data?.isSuccess) {
        setRoles(response.data.result);
      }
    });
  }
  const fetchBankList = async () => {
    try {
      const url = `${process.env.REACT_APP_NODE_URL}/api/get-bank-list`;
      const token = localStorage.getItem("rbacToken");
      const config = {
        headers: {
          token: token,
        },
      };

      const response = await Axios.get(url, config);

      if (response.data?.isSuccess) {
        console.log(response.data.result, "response.data.result");
        setBankList(response.data.result);
      } else {
        console.error("API request was not successful");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  async function getBranchsFromDb() {
    const url = `${process.env.REACT_APP_NODE_URL}/api/users/branches-list`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await Axios.get(url, config).then((response) => {
      if (response.data?.isSuccess) {
        setBranchs(response.data.result);
      }
    });
  }
  const getDepartmentList = async () => {
    const url = `${process.env.REACT_APP_NODE_URL}/api/master/get-department-list`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await Axios.get(url, config).then((response) => {
      if (response.data.isSuccess) {
        setDepartmentList(response.data.result);
      }
    });
  };
  async function getDspList() {
    const url = `${process.env.REACT_APP_NODE_URL}/api/employees/get-employee-list`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await Axios.get(url, config).then((response) => {
      if (response.data) {
        if (response.data.isSuccess) {
          setReportinManagerList(response.data.result);
        }
      }
    });
  }

  useEffect(() => {
    getBranchsFromDb();
    getRolesFromDb();
    fetchBankList();
    getDepartmentList();
    getDspList();
  }, []);

  function makeSelected(e, side, item) {
    if (side === "rightSide") {
      rightArrowBtn.current.classList.remove("disabledBtn");
      Array.from(selectInp.current.childNodes).forEach((i) => {
        i.classList.remove("checked");
      });
    } else {
      Array.from(selectedInp.current.childNodes).forEach((i) => {
        i.classList.remove("checked");
      });
      leftArrowBtn.current.classList.remove("disabledBtn");
    }
    e.currentTarget.classList.add("checked");
  }

  async function getUserBranchRole(id) {
    const url = `${process.env.REACT_APP_NODE_URL}/api/users/get-user-details/${id}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await Axios.get(url, config).then((response) => {
      if (response.data?.isSuccess) {
        console.log(response.data.result, "getUserBrsnch");
        setBranchRoles(response.data.result);
      }
    });
  }
  useEffect(() => {
    if (branches.length > 0 && workFor === "Edit" && editemployeeData) {
      const id = editemployeeData.id;
      getUserBranchRole(id);
      setAccessType(editemployeeData.login_access);
    }
  }, [branches]);

  function editBranchRole() {
    const itemList = selectedInp.current;
    const selectedItems = itemList.getElementsByClassName("checked");
    const checkId = selectedItems[0].value;
    setBranchId(checkId);
    setPopUpScreen(true);
  }
  function rightClick() {
    let tempAr = [];

    const itemList = selectInp.current;
    const selectedItems = itemList.getElementsByClassName("checked");
    console.log(selectedItems, "+_+_+_+");
    const checkId = selectedItems[0].value;
    setBranchId(checkId);
    setPopUpScreen(true);

    Array.from(selectInp.current.childNodes).forEach((i) => {
      i.classList.remove("checked");
    });

    rightArrowBtn.current.classList.add("disabledBtn");
  }

  function leftClick() {
    const itemList = selectedInp.current;
    const selectedItems = itemList.getElementsByClassName("checked");
    const checkId = selectedItems[0].value;
    let newResult = Array.from(branchRoles).filter((item) => {
      return item != checkId;
    });
    let tempObj = { ...branchRoles };
    delete tempObj[checkId];
    setBranchRoles(tempObj);

    Array.from(selectedInp.current.childNodes).forEach((i) => {
      i.classList.remove("checked");
    });
    leftArrowBtn.current.classList.add("disabledBtn");
  }

  function callBackLeft(checkId) {
    const tempAr = branchRoles[branchId];
    const newAr = tempAr.filter((i) => {
      return i != checkId;
    });
    if (
      Object.keys(branchRoles).length == 1 &&
      Object.values(branchRoles)[0].length == 1
    ) {
      setBranchRoles({});
    } else {
      setBranchRoles((branchRoles) => ({ ...branchRoles, [branchId]: newAr }));
    }
  }
  function callBackFun(checkId) {
    const tempAr = [];
    if (branchRoles[branchId] != undefined) {
      if (branchRoles[branchId] && !branchRoles[branchId].includes(checkId)) {
        branchRoles[branchId].forEach((i) => {
          tempAr.push(i);
        });
        tempAr.push(checkId);
        setBranchRoles((branchRoles) => ({
          ...branchRoles,
          [branchId]: tempAr,
        }));
      }
    } else {
      tempAr.push(checkId);
      setBranchRoles((branchRoles) => ({ ...branchRoles, [branchId]: tempAr }));
    }
  }

  const connectedBranch = useMemo(() => {
    let tempCounter = 0;
    Object.keys(branchRoles).forEach((item, index) => {
      let findBranch = branches.find((i) => {
        return i.id == item;
      });
      console.log("findBranch", findBranch);
      if (findBranch) {
        tempCounter++;
      }
    });
    return tempCounter;
  }, [branchRoles]);
  const showSelectedData = useMemo(() => {
    let tempAr = [];
    if (Object.keys(branchRoles).length > 0) {
      Object.keys(branchRoles).forEach((item, index) => {
        let tempObj = {};
        let findBranch = branches.find((i) => {
          return i.id == item;
        });
        if (findBranch) {
          tempObj["branch"] = findBranch;
          let tempArNested = [];
          branchRoles[item].forEach((i) => {
            let result = roles.find((roleItem) => {
              return i == roleItem.id;
            });
            if (result) {
              // Ensure result is not undefined
              tempArNested.push(result);
            }
          });
          tempObj["role"] = tempArNested;
          tempAr.push(tempObj);
        }
      });
    }
    return tempAr;
  }, [branchRoles, branches, roles]);

  function confirmClicked() {
    setPopUpScreen(false);
  }

  function handleSubmit() {
    console.log("userData");
    console.log("branchRoles");
  }

  const handleIconClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Trigger file input click using ref
    }
  };

  function handleCancel() {
    navigate(-1);
  }

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    console.log(file, "**********");
    if (file) {
      setPreview(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result); // Set the image preview
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    }
  };

  const handleChange = (event) => {
    setAccessType(event.target.defaultValue);
  };

  useEffect(() => {
    console.log(editemployeeSliceState, "Edit Slice---------");
    if (editemployeeSliceState.message.isSuccess) {
      if (editemployeeSliceState.message.result === "success") {
        dispatch(setShowMessage(t.employeeupdated || "Employee updated successfully"));
        dispatch(clearEditemployeeState());
        navigate("/administration/employees");
      }
    }
  }, [editemployeeSliceState]);

  const onSubmit = (values, { setSubmitting, resetForm }) => {
    if (Object.keys(branchRoles).length > 0) {
      values["branchRole"] = branchRoles;
      values["login_access"] = accessType;

      // Create FormData object to send image along with other data
      const formData = new FormData();
      formData.append("accountNumber", values.accountNumber);
      formData.append("accountType", values.accountType);
      formData.append("bankbranch", values.bankbranch);
      formData.append("bankname", values.bankname);
      formData.append("birthdate", values.birthdate);
      formData.append("bloodgroup", values.bloodgroup);
      formData.append("firstName", values.firstName);
      formData.append("ifscCode", values.ifscCode);
      formData.append("lastName", values.lastName);
      formData.append("login_access", values.login_access);
      formData.append("password", values.password);
      formData.append("phone", values.phone);
      formData.append("reportingManager", values.reportingManager);
      formData.append("branchRole", JSON.stringify(values.branchRole));
      formData.append("department", values.department);
      formData.append("email", values.email);

      if (preview) {
        formData.append("image", preview); // Add image to form data
      }

      if (workFor === "Add") {
        console.log(values, "___Submitted Data___");
        dispatch(addemployeeToDb(formData));
      } else {
        console.log(values, "___Submitted Data___");
        formData.append("document_id", editemployeeData.document_id);
        formData.append("userId", editemployeeData.id);
        dispatch(editemployeeUpdateToDb(formData));
      }
    } else {
      dispatch(setShowMessage(t.pleaseselectbranchroles || "Please Select Branch Roles"));
    }
    setTimeout(() => {
      // alert(JSON.stringify(values, null, 2));
      resetForm();
      setSubmitting(false);
    }, 400);
  };
  return (
    <Container className="bg-white">
      <Row className="justify-content-md-center">
        <Col md={12}>
          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ isSubmitting, values }) => (
              <Form>
                <Row className="mb-1">
                  <div className="d-flex align-items-center justify-content-between">
                    <h5 className="m-0">{t.generaldetails || 'General Details'}</h5>
                    <Button
                      variant="outline-secondary"
                      className="text-muted m-1"
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      {t.back || 'BACK'}
                    </Button>
                  </div>
                </Row>

                <Row className="mb-0">
                  <Col md={4}>
                    <div className="d-flex align-items-center">
                      <div>
                        {/* Conditional rendering of the profile image or icon */}
                        {profileUrl && !image ? (
                          <img
                            src={`${process.env.REACT_APP_NODE_URL}/api/upload/${editemployeeData.document_path}`}
                            alt="Profile"
                            onClick={handleIconClick}
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "5px",
                              cursor: "pointer",
                              border: "1px solid grey", // Border for the image
                            }}
                          />
                        ) : image ? (
                          <img
                            src={image}
                            alt="User Preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "5px",
                              border: "1px solid grey", // Border for the image
                            }}
                          />
                        ) : (
                          <PersonIcon
                            style={{
                              fontSize: "100px",
                              cursor: "pointer",
                              border: "1px solid grey", // Border for the icon
                            }}
                            onClick={handleIconClick} // Open file dialog on icon click
                          />
                        )}
                        <p className="text-muted">{t.profilepicture || 'Profile Picture'}</p>
                      </div>
                    </div>
                    <input
                      type="file"
                      ref={fileInputRef} // Attach ref to the file input
                      accept="image/*"
                      onChange={handleImageChange}
                      className="form-control"
                      style={{ display: "none" }} // Hide the file input
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={4}>
                    <label htmlFor="firstName" className="form-label">
                      {t.firstname || 'First Name'}
                    </label>
                    <Field
                      type="text"
                      name="firstName"
                      className="form-control"
                    />
                    <ErrorMessage
                      name="firstName"
                      component={({ children }) => (
                        <span
                          style={{ color: "darkred", fontSize: "0.875rem" }}
                        >
                          {children}
                        </span>
                      )}
                    />
                  </Col>

                  <Col md={4}>
                    <label htmlFor="lastName" className="form-label">
                      {t.lastname || 'Last Name'}
                    </label>
                    <Field
                      type="text"
                      name="lastName"
                      className="form-control"
                    />
                    <ErrorMessage
                      name="lastName"
                      component={({ children }) => (
                        <span
                          style={{ color: "darkred", fontSize: "0.875rem" }}
                        >
                          {children}
                        </span>
                      )}
                    />
                  </Col>

                  <Col md={4}>
                    <label htmlFor="email" className="form-label">
                      {t.workemail || t.email || 'Work Email'}
                    </label>
                    <Field type="email" name="email" className="form-control" />
                    <ErrorMessage
                      name="email"
                      component={({ children }) => (
                        <span
                          style={{ color: "darkred", fontSize: "0.875rem" }}
                        >
                          {children}
                        </span>
                      )}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={4}>
                    <label htmlFor="phone" className="form-label">
                      {t.phoneno || 'Phone Number'}
                    </label>
                    <Field type="text" name="phone" className="form-control" />
                    <ErrorMessage
                      name="phone"
                      component={({ children }) => (
                        <span
                          style={{ color: "darkred", fontSize: "0.875rem" }}
                        >
                          {children}
                        </span>
                      )}
                    />
                  </Col>

                  <Col md={4}>
                    <label htmlFor="password" className="form-label">
                      {t.password || 'Password'}
                    </label>
                    <div style={{ position: "relative" }}>
                      <Field
                        type={showPassword ? "text" : "password"}
                        name="password"
                        className="form-control"
                      />
                      {values.password !== "passWord123!" && (
                        <InputAdornment
                          position="end"
                          style={{
                            position: "absolute",
                            right: 10,
                            top: "50%",
                            transform: "translateY(-50%)",
                          }}
                        >
                          <IconButton
                            onClick={togglePasswordVisibility}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      )}

                      <ErrorMessage
                        name="password"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </div>
                  </Col>

                  <Col md={4}>
                    <label htmlFor="birthdate" className="form-label">
                      {t.dateofbirth || 'Date of Birth'}
                    </label>
                    <Field
                      type="date"
                      name="birthdate"
                      className="form-control"
                    />
                    <ErrorMessage
                      name="birthdate"
                      component={({ children }) => (
                        <span
                          style={{ color: "darkred", fontSize: "0.875rem" }}
                        >
                          {children}
                        </span>
                      )}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={4}>
                    <label htmlFor="bloodgroup" className="form-label">
                      {t.bloodgroup || 'Blood Group'}
                    </label>
                    <Field
                      as="select"
                      name="bloodgroup"
                      className="form-control"
                    >
                      <option value="" label={t.selectbloodgroup || 'Select Blood Group'} />
                      {bloodGroups.map((group) => (
                        <option key={group} value={group} label={group} />
                      ))}
                    </Field>
                    <ErrorMessage
                      name="bloodgroup"
                      component={({ children }) => (
                        <span
                          style={{ color: "darkred", fontSize: "0.875rem" }}
                        >
                          {children}
                        </span>
                      )}
                    />
                  </Col>

                  {/* <Col md={4}>
                    <label htmlFor="position" className="form-label">
                      Position
                    </label>
                    <Field as="select" name="position" className="form-control">
                      <option value="" label="Select position" />
                      <option value="developer" label="Developer" />
                      <option value="designer" label="Designer" />
                      <option value="manager" label="Manager" />
                      <option value="analyst" label="Analyst" />
                    </Field>
                    <ErrorMessage
                      name="position"
                      component={({ children }) => (
                        <span
                          style={{ color: "darkred", fontSize: "0.875rem" }}
                        >
                          {children}
                        </span>
                      )}
                    />
                  </Col>

                  <Col md={4}>
                    <label htmlFor="department" className="form-label">
                      Department
                    </label>
                    <Field
                      as="select"
                      name="department"
                      className="form-control"
                    >
                      <option value="" label="Select department" />
                      <option value="hr" label="HR" />
                      <option value="engineering" label="Engineering" />
                      <option value="sales" label="Sales" />
                      <option value="marketing" label="Marketing" />
                    </Field>
                    <ErrorMessage
                      name="department"
                      component={({ children }) => (
                        <span
                          style={{ color: "darkred", fontSize: "0.875rem" }}
                        >
                          {children}
                        </span>
                      )}
                    />
                  </Col> */}
                </Row>

                <Row className="mb-3">
                  <div className="mb-2">
                    <h5 className="m-0">{t.bankdetails || 'Bank Details'}</h5>
                  </div>
                  <Col md={4}>
                    <label htmlFor="bankname" className="form-label">
                      {t.bankname || 'Bank Name'}
                    </label>
                    <Field as="select" name="bankname" className="form-control">
                      <option value="" label={t.selectbankname || 'Select Bank Name'} />
                      {banklist.map((bank) => (
                        <option
                          key={bank.id}
                          value={bank.bankname}
                          label={bank.bankname}
                        />
                      ))}
                    </Field>
                    <ErrorMessage
                      name="bankname"
                      component={({ children }) => (
                        <span
                          style={{ color: "darkred", fontSize: "0.875rem" }}
                        >
                          {children}
                        </span>
                      )}
                    />
                  </Col>

                  <Col md={4}>
                    <label htmlFor="bankbranch" className="form-label">
                      {t.bankbranch || 'Bank Branch'}
                    </label>
                    <Field
                      type="text"
                      name="bankbranch"
                      className="form-control"
                    />
                    <ErrorMessage
                      name="bankbranch"
                      component={({ children }) => (
                        <span
                          style={{ color: "darkred", fontSize: "0.875rem" }}
                        >
                          {children}
                        </span>
                      )}
                    />
                  </Col>

                  <Col md={4}>
                    <label htmlFor="accountNumber" className="form-label">
                      {t.accountnumber || 'Account Number'}
                    </label>
                    <Field
                      type="text"
                      name="accountNumber"
                      className="form-control"
                    />
                    <ErrorMessage
                      name="accountNumber"
                      component={({ children }) => (
                        <span
                          style={{ color: "darkred", fontSize: "0.875rem" }}
                        >
                          {children}
                        </span>
                      )}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={4}>
                    <label htmlFor="accountType" className="form-label">
                      {t.accounttype || 'Account Type'}
                    </label>
                    <Field
                      as="select"
                      name="accountType"
                      className="form-control"
                    >
                      <option value="" label={t.selectaccounttype || 'Select Account Type'} />
                      <option value="Savings" label="Savings" />
                      <option value="Salery" label="Salery" />
                      <option value="Current" label="Current" />
                    </Field>
                    <ErrorMessage
                      name="accountType"
                      component={({ children }) => (
                        <span
                          style={{ color: "darkred", fontSize: "0.875rem" }}
                        >
                          {children}
                        </span>
                      )}
                    />
                  </Col>
                  <Col md={4}>
                    <label htmlFor="ifscCode" className="form-label">
                      IFSC Code
                    </label>
                    <Field
                      type="text"
                      name="ifscCode"
                      className="form-control"
                    />
                    <ErrorMessage
                      name="ifscCode"
                      component={({ children }) => (
                        <span
                          style={{ color: "darkred", fontSize: "0.875rem" }}
                        >
                          {children}
                        </span>
                      )}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <div className="mb-2">
                    <h5 className="m-0">{t.jobinformation || 'Job Information'}</h5>
                  </div>
                  <Col md={4}>
                    <label htmlFor="department" className="form-label">
                      {t.department || 'Department'}
                    </label>
                    <Field
                      as="select"
                      name="department"
                      className="form-control"
                    >
                      <option value="" label="Select Department" />
                      {departmentList.map((department) => (
                        <option
                          key={department.id}
                          value={department.id}
                          label={department.name}
                        />
                      ))}
                    </Field>
                    <ErrorMessage
                      name="department"
                      component={({ children }) => (
                        <span
                          style={{ color: "darkred", fontSize: "0.875rem" }}
                        >
                          {children}
                        </span>
                      )}
                    />
                  </Col>

                  <Col md={4}>
                    <label htmlFor="reportingManager" className="form-label">
                      {t.reportingmanager || 'Reporting Manager'}
                    </label>
                    <Field
                      as="select"
                      name="reportingManager"
                      className="form-control"
                    >
                      <option value="" label={t.selectreportingmanager || 'Select Reporting Manager'} />
                      {reportinManagerList &&
                        reportinManagerList.length > 0 &&
                        reportinManagerList.map((manager, index) => (
                          <option key={index} value={manager.id}>
                            {manager.first_name} {manager.last_name}
                          </option>
                        ))}
                    </Field>
                    <ErrorMessage
                      name="reportingManager"
                      component={({ children }) => (
                        <span
                          style={{ color: "darkred", fontSize: "0.875rem" }}
                        >
                          {children}
                        </span>
                      )}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <div className="mb-2">
                    <h5 className="m-0">{t.accesslevel || 'Access Level'}</h5>
                  </div>
                  <div className="">
                    <main className="mt-2 border border-muted p-1">
                      <div>
                        {/* ===========Access Level start========== */}
                        {/* <div className="row px-2">
                          <div className="col-6">Admin</div>
                          <div className="col-6">No Access</div>
                        </div>
                        <main className="m-0">
                          <div className="row m-0">
                            <section className="d-flex mt-1 flex-column col-12">
                              <div className="row">
                                <div className="col-6">
                                  <div className="noAccess border border-muted">
                                    <div className="d-flex">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="25"
                                        height="25"
                                        fill="currentColor"
                                        className="bi bi-person-fill-check text-success"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                        <path d="M2 13c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z" />
                                      </svg>
                                      <h6 className="fw-bold ms-3 mt-1">
                                        Super Admin
                                      </h6>
                                    </div>
                                    <p className="ms-4 text-muted">
                                      Admin have all rights and able to do all
                                      things.
                                    </p>
                                  </div>
                                </div>
                                <div className="col-6 noAccessDiv">
                                  <div className="noAccess border border-muted">
                                    <div className="d-flex">
                                      <img src="/noAccess.png" alt="Logo" />
                                      <h6 className="fw-bold ms-2">
                                        No Access
                                      </h6>
                                    </div>
                                    <p className="ms-4 text-muted">
                                      They can log in with the selected access
                                      level.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </main> */}
                      </div>
                      <div className=" row m-0">
                        <section className="d-flex mt-2 flex-column  col-12">
                          <main className="mb-2 text-muted">
                            <h5 className="text-muted">{t.loginaccess || 'Login Access'}</h5>

                            <label className="ms-2">
                              <input
                                type="radio"
                                name="accessType"
                                value="webaccess"
                                checked={accessType === "webaccess"}
                                onChange={handleChange}
                                className="me-2"
                              />
                              {t.webaccess || 'Web Access'}
                            </label>

                            <label className="ms-5">
                              <input
                                type="radio"
                                name="accessType"
                                value="appaccess"
                                checked={accessType === "appaccess"}
                                onChange={handleChange}
                                className="me-2"
                              />
                              {t.appaccess || 'App Access'}
                            </label>

                            <label className="ms-5">
                              <input
                                type="radio"
                                name="accessType"
                                value="bothaccess"
                                checked={accessType === "bothaccess"}
                                onChange={handleChange}
                                className="me-2"
                              />
                              {t.bothaccess || 'Both Access'}
                            </label>
                          </main>

                          <h5 className="m-0 text-muted">
                            {t.selectbranch || 'Select Branch'}
                          </h5>
                          <label className="myLabel">
                            {t.selectoneormorebranch || 'Select one or more branch'}
                          </label>
                          <div className="swapSelection d-flex flex-column flex-md-row mt-2">
                            <main>
                              <label className="pb-2">
                                {t.availablebranches || 'Available branches'} (
                                {branches && branches.length > 0
                                  ? branches.length
                                  : 0}
                                )
                              </label>
                              <ul
                                ref={selectInp}
                                name="selectRole"
                                className="inputElement"
                              >
                                {branches.length > 0 &&
                                  branches.map((item, index) => {
                                    return (
                                      <li
                                        onClick={(event) => {
                                          makeSelected(
                                            event,
                                            "rightSide",
                                            item
                                          );
                                        }}
                                        className="text-uppercase"
                                        key={index}
                                        value={item.id}
                                      >
                                        <div className="d-flex align-items-center">
                                          {/* <input type='checkbox' className='m-2 myCheckBox inputElement' onChange={(e) => { onChangeHandler(e) }} name="enableUser" /> */}
                                          <p className="ms-1">{item.name}</p>
                                        </div>
                                      </li>
                                    );
                                  })}
                              </ul>
                            </main>

                            <div className="d-flex flex-row flex-md-column justify-content-around allBtnsMain m-3">
                              <div
                                ref={rightArrowBtn}
                                className="arrowBtn disabledBtn"
                                name="rightDiv"
                                onClick={rightClick}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="currentColor"
                                  className="bi bi-arrow-right"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                  />
                                </svg>
                              </div>
                              <div
                                ref={leftArrowBtn}
                                className="arrowBtn disabledBtn"
                                onClick={leftClick}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-arrow-left"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                                  />
                                </svg>
                              </div>
                            </div>
                            <main>
                              <label className="pb-2">
                                {t.selectedcount || 'Selected'} (
                                {branchRoles && Object.keys(branchRoles).length
                                  ? connectedBranch
                                  : 0}
                                )
                              </label>

                              <ul
                                ref={selectedInp}
                                className="inputElement"
                                name="selectedRole"
                              >
                                {branchRoles &&
                                  Object.keys(branchRoles).length > 0 &&
                                  showSelectedData.map((item, index) => {
                                    return (
                                      <>
                                        <li
                                          value={item.branch.id}
                                          onDoubleClick={editBranchRole}
                                          onClick={(event) => {
                                            makeSelected(
                                              event,
                                              "leftSide",
                                              item.branch.id
                                            );
                                          }}
                                          className="text-uppercase"
                                          key={index}
                                        >
                                          <div className="d-flex flex-wrap align-items-center  justify-content-between">
                                            {item.branch.name}

                                            <div className="d-flex flex-wrap">
                                              {item.role.map((i, index) => {
                                                return (
                                                  <span
                                                    key={index}
                                                    value={i.id}
                                                    className="myTag myH7 m-1"
                                                  >
                                                    {i.role}
                                                  </span>
                                                );
                                              })}
                                            </div>
                                          </div>
                                        </li>
                                      </>
                                    );
                                  })}
                              </ul>
                            </main>
                          </div>
                        </section>
                        <section className="d-flex mt-3  flex-column flex-sm-row">
                          <Button
                            variant="outline-secondary"
                            className="m-1 px-5"
                            type="submit"
                            disabled={isSubmitting}
                          >
                            {workFor === "Edit" ? (t.save || 'Save') : (t.addemployee || 'Add Employee')}
                          </Button>
                          <Button
                            variant="outline-secondary"
                            className="m-1 px-4"
                            onClick={handleCancel}
                          >
                            {t.cancel || 'Cancel'}
                          </Button>
                        </section>
                      </div>
                    </main>
                  </div>
                </Row>
              </Form>
            )}
          </Formik>
        </Col>
        {popUpScreen && (
          <section className="popUpScreen">
            <main
              className="shadow col-10 col-md-8 col-lg-7  p-3"
              style={{ position: "fixed" }}
            >
              <h5 className="m-0">Select role</h5>
              <div className=" row m-0">
                <section className="d-flex mt-3 flex-column col-12">
                  <label className="myLabel">Select one or more roles</label>
                  <SwapSection
                    workFor="roles"
                    currentId={branchId}
                    selectedData={branchRoles}
                    setSelectedData={setBranchRoles}
                    callBackLeft={callBackLeft}
                    callBackFun={callBackFun}
                    selectionData={roles}
                  />
                </section>
                <section className="d-flex mt-3  flex-column flex-sm-row">
                  <Button
                    variant="outline-secondary"
                    className="m-1 px-4"
                    onClick={confirmClicked}
                  >
                    {t.done || 'Done'}
                  </Button>
                  <Button
                    variant="outline-secondary"
                    className="m-1 px-3"
                    onClick={() => {
                      confirmClicked();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="outline-secondary"
                    style={{
                      width: "70px",
                      height: "35px",
                      fontSize: "14px",
                      borderRadius: "20px",
                      position: "absolute",
                      top: "15px",
                      right: "10px",
                      padding: "5px 10px",
                      fontWeight: "bold",
                    }}
                    onClick={() => {
                      confirmClicked();
                    }}
                  >
                    {t.back || 'BACK'}
                  </Button>
                </section>
              </div>
            </main>
          </section>
        )}
      </Row>
    </Container>
  );
};

export default EmployeeForm;
